import React, { useState } from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

//import logo from '../nocapeu.png';
import logo from '../3X_red_512x512_centered_horizontal_only.png';

const Wrapper = styled.a.attrs({
  className: 'navbar-brand',
})`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-basis: 10%;
  img {
    margin-right: 10px;
  }
`;

const Nav = styled.nav.attrs({
  className: 'navbar navbar-expand-lg',
})`
  background-color: #1e1e1e; /* VS Code dark theme background */
  color: #d4d4d4; /* VS Code light text color */
  border-bottom: 1px solid #333; /* Subtle border for separation */
  margin: 0; /* Remove white margins */
  padding: 0 20px; /* Add padding for spacing */
  width: 100%; /* Ensure navbar spans the full width */
  box-sizing: border-box; /* Include padding in width calculation */
`;

const LinkTextCenter = styled.div`
  text-align: center;
  flex-basis: 80%;
  white-space: pre-wrap;
  a {
    color: #569cd6; /* VS Code blue link color */
    text-decoration: none;
    &:hover {
      color: #9cdcfe; /* Lighter blue on hover */
      text-decoration: underline;
    }
  }
`;

const LinkTextRight = styled(Link)`
  text-align: right;
  flex-basis: 10%;
  color: #d4d4d4; /* VS Code light text color */
  &:hover {
    color: #9cdcfe; /* Lighter blue on hover */
  }
`;

const NavBar = () => {
  const [whatIsThisLink, setWhatIsThisLink] = useState('What is this?');
  const [centerTitle, setCenterTitle] = useState('CLAN BATTLES TEAM COMPOSER');

  const handleInstructions = () => {
    if (whatIsThisLink === 'What is this?') {
      setCenterTitle(
        <LinkTextCenter style={{ color: 'white', fontSize: '16px', textAlign: 'center', flexBasis: '80%' }}>
          <p>
            Tired of "what ship do you have," "are you good in it," and similar questions? Night after night, CB season after CB season? So was I, no more. 
            Select your players, pick your comp, and a table is generated based on your settings, representing the highest combined PR possible. Guess less, play more.
          </p>
          <p>
            How does it work? The server pulls all players' stats for all ships from WG (hidden profiles are not considered), 
            then uses the <a href="https://en.wikipedia.org/wiki/Hungarian_algorithm" target="_blank" rel="noopener noreferrer">Hungarian algorithm </a> 
            to calculate the maximum total combined PR player-to-ship assignments, while guaranteeing all ships are assigned if at all possible.
          </p>
          <p>
            At this time, WG allows a maximum of 10 API calls per second. Stats for up to 100 ships for each player can be pulled per API call. 
            There are 848 ships in the game as of April 2025. When adding all clan players, that's up to 50 players * 9 calls / 10 per second = 45 seconds 
            to send all API calls. WG takes their time replying so it takes 2-3 minutes to populate the "Available Players" list. Add S&H and taxes to that. 
            The stats data is saved into the local DB for 24 hours so subsequent pulls should be faster.
          </p>
        </LinkTextCenter>
      );
      setWhatIsThisLink('I wanna talk to your manager!');
    } else if (whatIsThisLink === 'I wanna talk to your manager!') {
      setCenterTitle(
        <LinkTextCenter style={{ color: 'white', fontSize: '16px', textAlign: 'center', flexBasis: '80%' }}>
          <p>
            DM Bozo128 on 3X discord : <a href="https://discord.gg/PSzA2fqP" target="_blank" rel="noopener noreferrer">https://discord.gg/PSzA2fqP</a>
          </p>
          <p>
            If reporting an issue make sure to provide a screenshot and how to reproduce it.
          </p>
          <p>
            Suggestions are welcome, I'll get ChatGPT on it.
          </p>
        </LinkTextCenter>
      );
      setWhatIsThisLink('All righty then');
    } else if (whatIsThisLink === 'All righty then') {
      setWhatIsThisLink('What is this?');
      setCenterTitle('CLAN BATTLES TEAM COMPOSER');
    }
  };

  return (
    <Nav>
      <Wrapper href="/">
        <img src={logo} width="50" height="50" alt="Logo" />
      </Wrapper>
      <LinkTextCenter className="navbar-brand">
        {centerTitle}
      </LinkTextCenter>
      <LinkTextRight className="navbar-brand" onClick={handleInstructions}>
        {whatIsThisLink}
      </LinkTextRight>
    </Nav>
  );
};

export default NavBar;
